import React from "react";
import { CommonTable } from "~/app/index";
import TableToolbar from "./TableToolbar";
import {mapCSVtoTable} from '~/app/utilities';

class ClaimsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = { searchTerm: ""};
  }
  render() {
    const { uploaded_claims } = this.props;
    const mappedClaims = mapCSVtoTable(uploaded_claims);

    if (mappedClaims.length === 0) {
      return <div></div>;
    } else {
      return (
        <div className="box table-position">
          <div className="box-header">
            <div className="header-name">Claims Table</div>
          </div>
          <div className="table-toolbar">
            <TableToolbar
              onSearchTermChange={term => this.setState({ searchTerm: term })}
              renderedLocation={"submit_claims"}
              numClaims={mappedClaims.length}
            />
          </div>
          <div className="box-content">
            <CommonTable
              data={mappedClaims}
              searchTerm={this.state.searchTerm}
            />
            {/* <ClaimsLogModal /> */}

          </div>
        </div>
      );
    }
  }
}



export default ClaimsTable;





// WEBPACK FOOTER //
// ./src/app/submit_claims/claims_table/ClaimsTable.js